/** SessionStorage key: checkout payload saved before Stripe `confirmPayment` (redirect methods e.g. Klarna). */
export const STRIPE_PENDING_CHECKOUT_KEY = "vaStripePendingCheckout";
